// extracted by mini-css-extract-plugin
export default {"title":"title-u6pHu","separator":"separator-sc7KF"};